import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { productTypeListPC, productTypeList } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 分类列表
    _this.productTypeList = [];
    // 分类列表子分类
    _this.productTypeChildren = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getProductTypeList();
    }
  }, {
    key: "getProductTypeList",
    value: function () {
      var _getProductTypeList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return productTypeListPC({
                companyId: 1
              });
            case 2:
              res = _context.sent;
              this.productTypeList = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProductTypeList() {
        return _getProductTypeList.apply(this, arguments);
      }
      return getProductTypeList;
    }()
  }, {
    key: "dropdownClick",
    value: function () {
      var _dropdownClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productTypeId) {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return productTypeList({
                productTypeId: productTypeId,
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.productTypeChildren = res.data.data.children;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function dropdownClick(_x) {
        return _dropdownClick.apply(this, arguments);
      }
      return dropdownClick;
    }()
  }, {
    key: "goDetails",
    value: function goDetails(productTypeId) {
      window.location.href = "/classify?productTypeId=".concat(productTypeId);
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'DropDown'
})], default_1);
export default default_1;